export const KeyboardKey = {
  Enter: 'Enter',
  Escape: 'Escape',
  ArrowDown: 'ArrowDown',
  ArrowUp: 'ArrowUp',
  Space: ' ',
} as const;

export type KeyboardKeyName = (typeof KeyboardKey)[keyof typeof KeyboardKey];

export const MENU_NAVIGATION_KEYS = new Set<string>([
  KeyboardKey.ArrowDown,
  KeyboardKey.ArrowUp,
  KeyboardKey.Enter,
  KeyboardKey.Escape,
]);
